import { Component, OnInit } from '@angular/core';
import { ColDef, GridApi } from 'ag-grid-community';
import { logisticaModulo as diccionarios } from '../../logistica-diccionario';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { LogisticaService } from '../../service/logistica.services';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cancelar-viaje',
  templateUrl: './cancelar-viaje.component.html',
  styleUrls: ['./cancelar-viaje.component.css']
})
export class CancelarViajeComponent implements OnInit {
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID = diccionarios.agGrid;

  public loading: boolean = false;

  public frameworkComponents: any;
  public columnDefs: ColDef[] = [];
  public rowData: any[] = [];
  public rowSelection: any;
  public gridApi: GridApi;
  public gridColumnApi: any;
  public textoBuscar: string;

  public usuarioActual: any;

  constructor(
    private logisticaAPI: LogisticaService,
    private catalogos: CatalogosLogisticaService,
  ) {}

  ngOnInit(): void {
    this.usuarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.cargarGridcomponent();
    this.listar();
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent };
    this.columnDefs = this.catalogos.getColumnDefs();
    this.columnDefs.push({
      cellRenderer: 'buttonRenderer',
      initialPinned: 'left',
      width: 100,
      cellRendererParams: { onClick: this.cancelar.bind(this), label: 'Cancelar', colorBoton: 'btn btn-danger btn-block btn-sm' }
    });
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi?.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  listar() {
    this.rowData = [];
    this.logisticaAPI.getViajeByExcption(['FINALIZADO', 'ELIMINADO']).subscribe((res: any) => {
      if (res) this.rowData = res;
    }, (err) => {
      console.log(err.message);
    });
  }

  cancelar({ rowData }: any) {
    const idViaje = rowData?.idViaje;
    if (!idViaje) return;

    if (String(rowData?.estado ?? '').toUpperCase() === 'ELIMINADO') {
      Swal.fire({
        icon: 'info',
        title: 'Viaje ya cancelado',
        text: `El viaje ${idViaje} ya se encuentra en estado CANCELADO`,
      });
      return;
    }

    Swal.fire({
      title: 'Cancelar viaje',
      text: `¿Desea cancelar el viaje ${idViaje}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      cancelButtonText: 'No',
      confirmButtonText: 'Si, cancelar',
    }).then(result => {
      if (!result.isConfirmed) return;

      this.loading = true;
      const modificadoPor = this.usuarioActual?.login2 ?? this.usuarioActual?.login ?? '';
      this.logisticaAPI.updateViajeEstado(idViaje, 'ELIMINADO', modificadoPor).subscribe(() => {
        Swal.fire({
          icon: 'success',
          title: 'Cancelado',
          text: `El viaje ${idViaje} fue cancelado correctamente`,
        });
        this.listar();
        this.loading = false;
      }, (e) => {
        const msg = e?.error?.mensaje ?? e?.error?.message ?? 'Ocurrió un error al cancelar el viaje';
        Swal.fire({
          icon: 'warning',
          title: 'Error',
          text: msg,
        });
        this.loading = false;
      });
    });
  }
}

